module.exports = __webpack_public_path__ + "static/media/vlcc.6aebcab8.webp";